// extracted by mini-css-extract-plugin
export default {"menuItem":"Io3KWD","mobileOnly":"jgWa2y"};